import * as React from "react";
import classNames from "classnames";
import Icon, { TIconNames } from "../icons/icon";
import Spinner from "~/components/spinner/spinner";

type IOnClickFunction = (e: React.MouseEvent<HTMLButtonElement>) => void;

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    onClick?: IOnClickFunction;
    disabled?: boolean;
    className?: string;
    loading?: boolean;
    iconId?: TIconNames;
    isLarge?: boolean;
    isInverted?: boolean;
    isSecondary?: boolean;
}

const Button: React.SFC<IButtonProps> = props => {
    const baseClass = "button";
    const componentClasses = classNames(baseClass, props.className, {
        [`${baseClass}--large`]: props.isLarge,
        [`${baseClass}--inverted`]: props.isInverted,
        [`${baseClass}--secondary`]: props.isSecondary,
        [`${baseClass}--loading`]: props.loading
    });

    return (
        <button
            className={componentClasses}
            type={props.type || "button"}
            disabled={!!(props.disabled || props.loading)}
            onClick={e => {
                if (props.onClick) {
                    props.onClick(e);
                }
            }}
        >
            {props.iconId && <Icon iconId={props.iconId} className={`${baseClass}__icon`} />}
            {props.loading && <Spinner />}
            <span className={`${baseClass}__text`}>{props.children}</span>
        </button>
    );
};
export default Button;
